import React from "react";

const ExtrapayDetailRows = ({ rows }) => (
  <div>
    {rows.map((row) => (
      <div
        key={row.label}
        className="flex justify-content-between align-items-start gap-3 py-3"
        style={{ borderBottom: "1px solid var(--theme-border, #EBEBEB)" }}
      >
        <span className="text-sm" style={{ color: "var(--theme-text, #262626)" }}>
          {row.label}
        </span>
        <span
          className="text-sm text-right font-medium"
          style={{ color: "var(--theme-text, #262626)", wordBreak: "break-all" }}
        >
          {row.value}
        </span>
      </div>
    ))}
  </div>
);

export default ExtrapayDetailRows;
